import React, { FC } from 'react';
import Dialog from '../Dialog';

interface LabelPortalProps {
  show: boolean;
  title: string;
  message: React.ReactNode | string;
  cancelTranslation: string;
  onLabelDismiss: () => void;
}

export const LabelPortal: FC<LabelPortalProps> = ({
  title,
  message,
  show,
  cancelTranslation,
  onLabelDismiss,
}) => (
  <Dialog
    show={show}
    title={title}
    message={message}
    onDismiss={onLabelDismiss}
    actions={[
      {
        text: cancelTranslation,
        onClick: onLabelDismiss,
        variant: 'text',
        id: 'label-cancel',
      },
    ]}
  />
);